import "../../ExchangeMarketRunnerPrice.scss";

export default function EmptyExchangeMarketRow() {
  return (
    <span className="exchange__runner-prices">
      <span>
        <span className="exchange__runner-price blank"></span>
      </span>
      <span>
        <span className="exchange__runner-price blank"></span>
      </span>
      <span>
        <span className="exchange__runner-price blank"></span>
      </span>
      <span>
        <span className="exchange__runner-price blank"></span>
      </span>
      <span>
        <span className="exchange__runner-price blank"></span>
      </span>
      <span>
        <span className="exchange__runner-price blank"></span>
      </span>
    </span>
  );
}
